"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8648],{

/***/ 33358:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export Link */
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19521);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _colors__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22745);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  &,\n  &:hover {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var Link = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].a.attrs */ .ZP.a.attrs({
    target: "_blank",
    rel: "noreferrer"
})(_templateObject(), _colors__WEBPACK_IMPORTED_MODULE_1__.B1);
Link.propTypes = {
    href: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string.isRequired)
};
/* harmony default export */ __webpack_exports__["Z"] = (Link);


/***/ }),

/***/ 14720:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BR": function() { return /* binding */ getCommonFields; },
/* harmony export */   "Hs": function() { return /* binding */ getInitialValues; },
/* harmony export */   "J1": function() { return /* binding */ getSchema; },
/* harmony export */   "Q9": function() { return /* binding */ getDropdownValidator; },
/* harmony export */   "V5": function() { return /* binding */ getTextareaValidator; }
/* harmony export */ });
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74231);
/* harmony import */ var _tidb_community_common__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94174);


var _form = _tidb_community_common__WEBPACK_IMPORTED_MODULE_1__/* .utils.form */ .P6.cr, buildSchema = _form.buildSchema, buildInitialValues = _form.buildInitialValues;
var getDropdownValidator = function(param) {
    var lang = param.lang;
    return yup__WEBPACK_IMPORTED_MODULE_0__/* .mixed */ .nK().required(lang.required);
};
var getTextareaValidator = function(param1) {
    var lang = param1.lang, t = param1.t, limit = param1.limit, _isRequired = param1.isRequired, isRequired = _isRequired === void 0 ? true : _isRequired;
    var validator = yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().max(limit, function(param) {
        var max = param.max;
        return t("errors.limit", {
            max: max
        });
    });
    return isRequired ? validator.required(lang.required) : validator;
};
var getCommonFields = function(param) {
    var lang = param.lang;
    return {
        agreement: {
            name: "agreement",
            validator: yup__WEBPACK_IMPORTED_MODULE_0__/* .boolean */ .O7().required(lang.required).oneOf([
                true
            ], lang.agreement.privacy.error)
        }
    };
};
var getSchema = function(fields) {
    return buildSchema(fields);
};
var getInitialValues = function(fields) {
    return buildInitialValues(fields);
};


/***/ }),

/***/ 51844:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ CommonForm_component; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/ramda/es/index.js + 227 modules
var es = __webpack_require__(36486);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/antd/es/button/index.js
var es_button = __webpack_require__(71577);
// EXTERNAL MODULE: ./node_modules/antd/es/result/index.js + 5 modules
var result = __webpack_require__(33859);
// EXTERNAL MODULE: ./node_modules/antd/es/row/index.js
var row = __webpack_require__(71230);
// EXTERNAL MODULE: ./node_modules/antd/es/col/index.js
var col = __webpack_require__(15746);
// EXTERNAL MODULE: ./node_modules/formik-antd/es/form/form.js
var form_form = __webpack_require__(14271);
// EXTERNAL MODULE: ./node_modules/formik-antd/es/checkbox/index.js
var es_checkbox = __webpack_require__(42842);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82580);
// EXTERNAL MODULE: ./packages/ui/src/components/link/Link.component.js
var Link_component = __webpack_require__(33358);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 12 modules
var esm = __webpack_require__(10686);
// EXTERNAL MODULE: ./src/utils/index.js + 3 modules
var utils = __webpack_require__(59874);
// EXTERNAL MODULE: ./src/pages/contact-us/commonForm/commonForm.fields.js
var commonForm_fields = __webpack_require__(14720);
;// CONCATENATED MODULE: ./src/pages/contact-us/commonForm/CommonForm.component.js
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}










var FormComponent = function(param1) {
    var children = param1.children, submitApi = param1.submitApi, submitApiFormatter = param1.submitApiFormatter, formFields = param1.formFields, formLocalePath = param1.formLocalePath;
    var t = (0,esm/* useTranslation */.$G)("page-contact-us", "common").t;
    var ref = (0,react.useState)(false), isSubmitting = ref[0], setIsSubmitting = ref[1];
    var ref1 = (0,react.useState)(false), isSubmitted = ref1[0], setIsSubmitted = ref1[1];
    var lang = _objectSpread({}, t(formLocalePath, {
        returnObjects: true
    }), t("common:form", {
        returnObjects: true
    }));
    var agreementLang = lang.agreement;
    var fields = _objectSpread({}, (0,commonForm_fields/* getCommonFields */.BR)({
        lang: lang
    }), formFields);
    var validationSchema = (0,commonForm_fields/* getSchema */.J1)(fields);
    var initialValues = (0,commonForm_fields/* getInitialValues */.Hs)(fields);
    var agreement = fields.agreement;
    var onSubmit = utils/* form.wrapFormikSubmitFunction */.cr.wrapFormikSubmitFunction(function(_param) {
        var agreement = _param.agreement, values = _objectWithoutProperties(_param, [
            "agreement"
        ]);
        setIsSubmitting(true);
        return submitApi(submitApiFormatter ? submitApiFormatter(values) : values).then(function() {
            setIsSubmitted(true);
        }).finally(function() {
            setIsSubmitting(false);
        });
    });
    var formikProps = {
        initialValues: initialValues,
        onSubmit: onSubmit,
        validationSchema: validationSchema
    };
    if (isSubmitted) {
        var resultProps = {
            status: "success",
            subTitle: lang.submitSuccessful,
            extra: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(es_button/* default */.Z, {
                    type: "primary",
                    onClick: function() {
                        window.open(window.location, "_self").close();
                    },
                    children: lang.closePage
                }, "close"), 
            ]
        };
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(result/* default */.ZP, _objectSpread({}, resultProps));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, _objectSpread({}, formikProps, {
        children: function(param) {
            var errors = param.errors;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(form_form/* Form */.l, {
                layout: "vertical",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(row/* default */.Z, {
                    gutter: [
                        32,
                        16
                    ],
                    children: [
                        children,
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                            span: 24,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(form_form/* Form.Item */.l.Item, {
                                name: agreement.name,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(es_checkbox/* Checkbox */.X, _objectSpread({}, agreement, {
                                    children: [
                                        agreementLang.text,
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Link_component/* default */.Z, {
                                            href: agreementLang.privacy.link,
                                            children: agreementLang.privacy.title
                                        })
                                    ]
                                }))
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                            span: 24,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es_button/* default */.Z, {
                                type: "primary",
                                htmlType: "submit",
                                size: "small",
                                disabled: !es/* isEmpty */.xbD(errors),
                                loading: isSubmitting,
                                children: lang.submit
                            })
                        })
                    ]
                })
            });
        }
    }));
};
/* harmony default export */ var CommonForm_component = (FormComponent);

;// CONCATENATED MODULE: ./src/pages/contact-us/commonForm/index.js



/***/ }),

/***/ 64174:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Layout_component; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/ramda/es/index.js + 227 modules
var es = __webpack_require__(36486);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./node_modules/antd/es/skeleton/index.js + 8 modules
var skeleton = __webpack_require__(41080);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 12 modules
var esm = __webpack_require__(10686);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./packages/ui/src/colors.ts
var colors = __webpack_require__(22745);
// EXTERNAL MODULE: ./packages/ui/src/mixins.ts
var mixins = __webpack_require__(52873);
;// CONCATENATED MODULE: ./src/pages/contact-us/layout/layout.styled.js
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  background: ",
        ";\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  max-width: 600px;\n  margin: 0 auto;\n  flex: 1;\n  background: ",
        ";\n  margin-top: 3rem;\n  padding: 2.5rem 2rem;\n\n  .ant-form-item {\n    margin-bottom: 0;\n  }\n\n  .ant-result-subtitle {\n    ",
        ";\n  }\n\n  .ant-input-number,\n  .ant-picker {\n    width: 100%;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  margin-bottom: 2rem;\n\n  h1,\n  p {\n    ",
        ";\n  }\n\n  h1 {\n    ",
        ";\n    color: ",
        ";\n  }\n\n  p {\n    ",
        ";\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  text-align: center;\n  padding: 0 2rem;\n  margin: 1rem 0 3rem;\n\n  span {\n    position: relative;\n    top: 0.15em;\n    font-size: 1.2em;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ";\n  padding: 2rem;\n  flex-direction: column;\n  flex: 1;\n\n  svg {\n    width: 40%;\n    max-width: 280px;\n    min-width: 160px;\n  }\n\n  p {\n    ",
        ";\n    ",
        ";\n    margin-top: 2rem;\n  }\n\n  a {\n    ",
        ";\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}


var Container = styled_components_browser_esm/* default.div */.ZP.div(_templateObject(), colors.M2);
var Main = styled_components_browser_esm/* default.div */.ZP.div(_templateObject1(), colors.M1, mixins/* typography */.cp("p1"));
var Header = styled_components_browser_esm/* default.div */.ZP.div(_templateObject2(), mixins/* reset */.mc(), mixins/* typography */.cp("p2"), colors.F1, mixins/* typography */.cp("p3"), colors.C4);
var Footer = styled_components_browser_esm/* default.div */.ZP.div(_templateObject3(), colors.F2);
var ErrorContainer = styled_components_browser_esm/* default.div */.ZP.div(_templateObject4(), mixins/* flexCenter */._7(), mixins/* reset */.mc(), mixins/* typography */.cp("p1"), mixins/* resetLink */.GX());

;// CONCATENATED MODULE: ./src/pages/contact-us/layout/icon.svg
var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _circle, _path18, _circle2, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _circle3, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIcon = function SvgIcon(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1005.563 548.695"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M872.894 545.097c.096-.288 9.414-29.118-7.077-54.844l-1.684 1.079c15.964 24.903 6.957 52.854 6.864 53.134z",
    fill: "#e4e4e4"
  })), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M854.025 493.952a13.113 13.113 0 1 0 25.661-5.412c-1.494-7.086-14.164-24.722-21.25-23.228s-5.906 21.554-4.411 28.64zm2.389 33.143c6.324 6.835 17.638 6.65 17.638 6.65s1.06-11.267-5.264-18.1-17.638-6.65-17.638-6.65-1.06 11.266 5.264 18.1zm95.856 20.002c.227-.68 22.216-68.717-16.702-129.429l-3.973 2.547c37.672 58.77 16.416 124.732 16.197 125.391z",
    fill: "#e4e4e4"
  })), _path3 || (_path3 = /*#__PURE__*/react.createElement("path", {
    d: "M907.74 426.399a30.946 30.946 0 0 0 60.56-12.772c-3.528-16.723-33.427-58.343-50.15-54.816s-13.938 50.865-10.41 67.588zm5.638 78.215c14.925 16.128 41.625 15.69 41.625 15.69s2.502-26.586-12.423-42.714-41.625-15.69-41.625-15.69-2.502 26.586 12.423 42.714z",
    fill: "#e4e4e4"
  })), _path4 || (_path4 = /*#__PURE__*/react.createElement("path", {
    d: "m580.096 541.975-14.592-6.145-10.01-73.151H422.189l-10.85 72.852-13.056 6.528a3.1 3.1 0 0 0 1.387 5.873h179.223a3.1 3.1 0 0 0 1.203-5.957z",
    fill: "#e6e6e6"
  })), _path5 || (_path5 = /*#__PURE__*/react.createElement("path", {
    d: "M816.987 472.411H162.158a12.973 12.973 0 0 1-12.944-12.973v-92.34h680.718v92.34a12.974 12.974 0 0 1-12.945 12.973z",
    fill: "#ccc"
  })), _path6 || (_path6 = /*#__PURE__*/react.createElement("path", {
    d: "M830.616 410.74h-682V15.64A15.657 15.657 0 0 1 164.256 0h650.72a15.657 15.657 0 0 1 15.64 15.64z",
    fill: "#3f3d56"
  })), _path7 || (_path7 = /*#__PURE__*/react.createElement("path", {
    d: "M789.887 28.676h-600.54a12.065 12.065 0 0 0-12.05 12.06v329.27a12.065 12.065 0 0 0 12.05 12.06h600.54a12.072 12.072 0 0 0 12.05-12.06V40.736a12.072 12.072 0 0 0-12.05-12.06z",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/react.createElement("path", {
    d: "M295.797 28.676v353.39h-106.45a12.065 12.065 0 0 1-12.05-12.06V40.736a12.065 12.065 0 0 1 12.05-12.06z",
    fill: "#f0f0f0"
  })), _path9 || (_path9 = /*#__PURE__*/react.createElement("path", {
    d: "M207.978 207.197a8.406 8.406 0 0 0-10.263 7.799l-28.653 8.447 11.862 10.014 25.39-9.557a8.452 8.452 0 0 0 1.664-16.703z",
    fill: "#ffb6b6"
  })), _path10 || (_path10 = /*#__PURE__*/react.createElement("path", {
    d: "M92.205 270.771a11.952 11.952 0 0 1-3.808-23.276l58.064-19.6 45.292-16.5 5.559 19.455-39.984 26.347-62.624 13.311a12.025 12.025 0 0 1-2.499.263z",
    fill: "#6c63ff"
  })), _path11 || (_path11 = /*#__PURE__*/react.createElement("path", {
    fill: "#ffb6b6",
    d: "M128.541 538.792h8.152l3.879-31.445h-12.033l.002 31.445z"
  })), _path12 || (_path12 = /*#__PURE__*/react.createElement("path", {
    d: "M126.461 536.13h16.056a10.232 10.232 0 0 1 10.232 10.231v.333l-26.287.001z",
    fill: "#2f2e41"
  })), _path13 || (_path13 = /*#__PURE__*/react.createElement("path", {
    fill: "#ffb6b6",
    d: "M66.033 538.792h8.152l3.879-31.445H66.032l.001 31.445z"
  })), _path14 || (_path14 = /*#__PURE__*/react.createElement("path", {
    d: "M63.953 536.13H80.01a10.232 10.232 0 0 1 10.232 10.231v.333l-26.287.001zm1.999-185.954a43.784 43.784 0 0 0-2.327 27.55L61.297 533.71h17.905l10.024-85.782 16.625-56.523 17.954 43.888v91.471l17.29-1.034 9.31-97.086-10.64-69.158z",
    fill: "#2f2e41"
  })), _path15 || (_path15 = /*#__PURE__*/react.createElement("path", {
    d: "m131.452 228.818-15.294-4.654-3.99-7.98H92.522l-4.958 8.645s-19.95 7.314-20.614 42.558-3.325 91.767-3.325 91.767l78.66 11.214z",
    fill: "#6c63ff"
  })), _path16 || (_path16 = /*#__PURE__*/react.createElement("path", {
    d: "M154.035 364.056a8.406 8.406 0 0 0-5.495-11.66l-2.305-29.783-12.261 9.52 4.069 26.824a8.452 8.452 0 0 0 15.992 5.1z",
    fill: "#ffb6b6"
  })), _path17 || (_path17 = /*#__PURE__*/react.createElement("path", {
    d: "m133.116 348.706-17.458-44.588v-64.023a11.95 11.95 0 0 1 23.82-1.385l7.1 60.87 6.723 47.733z",
    fill: "#6c63ff"
  })), _circle || (_circle = /*#__PURE__*/react.createElement("circle", {
    cx: 106.114,
    cy: 186.2,
    r: 19.632,
    fill: "#ffb9b9"
  })), _path18 || (_path18 = /*#__PURE__*/react.createElement("path", {
    d: "M107.4 180.232c-.92 1.18-2.178 2.244-2.38 3.725-.15 1.097.329 2.182.375 3.288a4.388 4.388 0 0 1-4.102 4.393 4.868 4.868 0 0 0-3.134-1.792 2.891 2.891 0 0 0-2.976 1.72c-.583 1.647.766 3.32.983 5.054a10.452 10.452 0 0 1-.612 3.766c-.497 1.989-.63 4.093-1.503 5.949s-2.813 3.45-4.822 3.04c-1.69-.344-2.833-1.98-3.305-3.638s-.451-3.417-.793-5.106c-1.111-5.491-5.837-9.56-7.691-14.845-2.376-6.774.478-14.522 5.397-19.749a16.076 16.076 0 0 1 7.489-4.849c3.065-.78 6.306-.219 9.452-.553 3.364-.357 6.526-1.724 9.795-2.593s6.922-1.196 9.893.42c2.073 1.128 3.574 3.072 5.505 4.427a11.548 11.548 0 0 0 7.587 2.03l-3.21 1.404a10.31 10.31 0 0 0 4.324 2.369 7.48 7.48 0 0 1-4.609 1.618 5.264 5.264 0 0 0 3.317 2.55c-2.438 1.144-5.026 2.316-7.707 2.058-1.313-.126-2.568-.593-3.865-.833-2.764-.512-5.603.019-8.364.548-1.45.279-3.23.545-3.962 1.94-.61 1.16-.144 2.454-1.083 3.66z",
    fill: "#2f2e41"
  })), _circle2 || (_circle2 = /*#__PURE__*/react.createElement("circle", {
    cx: 236.547,
    cy: 205.371,
    r: 31.32,
    fill: "#6c63ff"
  })), _path19 || (_path19 = /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M255.339 205.371h-16.912v-16.913h-3.759v16.913h-16.913v3.758h16.913v16.913h3.759v-16.913h16.912v-3.758zM503.256 70.008a3.647 3.647 0 0 0-3.643 3.643v60.998a3.647 3.647 0 0 0 3.643 3.644h245.902a3.647 3.647 0 0 0 3.643-3.644V73.651a3.647 3.647 0 0 0-3.643-3.643z"
  })), _path20 || (_path20 = /*#__PURE__*/react.createElement("path", {
    d: "M503.256 70.008a3.647 3.647 0 0 0-3.643 3.643v60.998a3.647 3.647 0 0 0 3.643 3.644h245.902a3.647 3.647 0 0 0 3.643-3.644V73.651a3.647 3.647 0 0 0-3.643-3.643z",
    fill: "#e6e6e6"
  })), _path21 || (_path21 = /*#__PURE__*/react.createElement("path", {
    d: "M503.71 134.194h244.993V74.107H503.71z",
    fill: "#fff"
  })), _path22 || (_path22 = /*#__PURE__*/react.createElement("path", {
    d: "M531.566 91.4a3.188 3.188 0 0 0 0 6.375h189.273a3.188 3.188 0 1 0 .003-6.375H531.566zm0 19.126a3.188 3.188 0 0 0 0 6.375h189.273a3.188 3.188 0 0 0 .015-6.375H531.566z",
    fill: "#e4e4e4"
  })), _path23 || (_path23 = /*#__PURE__*/react.createElement("path", {
    d: "M332.256 173.508a3.647 3.647 0 0 0-3.643 3.643v60.998a3.647 3.647 0 0 0 3.643 3.644h245.902a3.647 3.647 0 0 0 3.643-3.644v-60.998a3.647 3.647 0 0 0-3.643-3.643z",
    fill: "#fff"
  })), _path24 || (_path24 = /*#__PURE__*/react.createElement("path", {
    d: "M332.256 173.508a3.647 3.647 0 0 0-3.643 3.643v60.998a3.647 3.647 0 0 0 3.643 3.644h245.902a3.647 3.647 0 0 0 3.643-3.644v-60.998a3.647 3.647 0 0 0-3.643-3.643z",
    fill: "#e6e6e6"
  })), _path25 || (_path25 = /*#__PURE__*/react.createElement("path", {
    d: "M332.71 237.694h244.993v-60.087H332.71z",
    fill: "#fff"
  })), _path26 || (_path26 = /*#__PURE__*/react.createElement("path", {
    d: "M360.566 194.9a3.188 3.188 0 0 0 0 6.375h189.273a3.188 3.188 0 1 0 .003-6.375H360.566zm0 19.126a3.188 3.188 0 0 0 0 6.375h189.273a3.188 3.188 0 0 0 .015-6.375H360.566z",
    fill: "#e4e4e4"
  })), _path27 || (_path27 = /*#__PURE__*/react.createElement("path", {
    d: "M631.992 337.221a7.536 7.536 0 0 0 6.405-9.619l21.793-15.566-12.988-5.001-18.704 15.549a7.577 7.577 0 0 0 3.494 14.637z",
    fill: "#ffb7b7"
  })), _path28 || (_path28 = /*#__PURE__*/react.createElement("path", {
    d: "m644.091 326.97-7.23-12.349.154-.175 29.17-33.208 22.648-38.623 19.667 2.506.29 5.945-.059.089-31.246 46.97-.033.028z",
    fill: "#3f3d56"
  })), _path29 || (_path29 = /*#__PURE__*/react.createElement("path", {
    fill: "#ffb7b7",
    d: "m740.467 535.914-11.121-.001-5.292-42.899 16.415.001-.002 42.899z"
  })), _path30 || (_path30 = /*#__PURE__*/react.createElement("path", {
    d: "m743.304 546.695-35.862-.001v-.454a13.96 13.96 0 0 1 13.958-13.958h21.904z",
    fill: "#2f2e41"
  })), _path31 || (_path31 = /*#__PURE__*/react.createElement("path", {
    fill: "#ffb7b7",
    d: "m644.748 535.55-10.818-2.583 4.816-42.955 15.966 3.812-9.964 41.726z"
  })), _path32 || (_path32 = /*#__PURE__*/react.createElement("path", {
    d: "m645.003 546.695-34.88-8.33.104-.44a13.96 13.96 0 0 1 16.819-10.336l21.305 5.088zm42.97-323.693V204.28a25.086 25.086 0 0 1 50.172 0V223a3.374 3.374 0 0 1-3.37 3.37h-43.433a3.374 3.374 0 0 1-3.37-3.37z",
    fill: "#2f2e41"
  })), _circle3 || (_circle3 = /*#__PURE__*/react.createElement("circle", {
    cx: 706.868,
    cy: 207.695,
    r: 18.392,
    fill: "#ffb7b7"
  })), _path33 || (_path33 = /*#__PURE__*/react.createElement("path", {
    d: "M682.038 205.778a19.867 19.867 0 0 1 19.844-19.844h3.745a19.867 19.867 0 0 1 19.844 19.844v.375h-7.913l-2.699-7.558-.54 7.558h-4.089l-1.362-3.813-.272 3.813h-26.558z",
    fill: "#2f2e41"
  })), _path34 || (_path34 = /*#__PURE__*/react.createElement("path", {
    d: "m717.596 304.768-46.83-1.782-2.618-30.637c-2.019-5.608-2.052-10.423-.097-14.31a14.324 14.324 0 0 1 7.908-6.836l10.247-12.376a13.947 13.947 0 0 1 10.83-5.048l26.623.182c.642-.386 4.535-2.364 12.212.964 8.327 3.61 6.393 16.147 6.373 16.273l-.02.118-.091.077-17.71 14.914z",
    fill: "#3f3d56"
  })), _path35 || (_path35 = /*#__PURE__*/react.createElement("path", {
    fill: "#2f2e41",
    d: "m671.139 299.694-22.151 40.386-16.794 183.737 18.975 5.795 33.587-143.73 38.98 139.652 22.745.569-15.487-161.159-13.534-62.396-46.321-2.854z"
  })), _path36 || (_path36 = /*#__PURE__*/react.createElement("path", {
    d: "M527.776 269.758a3.647 3.647 0 0 0-4.59 2.342l-18.809 58.025a3.647 3.647 0 0 0 2.342 4.59l233.919 75.828a3.647 3.647 0 0 0 4.589-2.342l18.81-58.025a3.647 3.647 0 0 0-2.342-4.59z",
    fill: "#fff"
  })), _path37 || (_path37 = /*#__PURE__*/react.createElement("path", {
    d: "M527.776 269.758a3.647 3.647 0 0 0-4.59 2.342l-18.809 58.025a3.647 3.647 0 0 0 2.342 4.59l233.919 75.828a3.647 3.647 0 0 0 4.589-2.342l18.81-58.025a3.647 3.647 0 0 0-2.342-4.59z",
    fill: "#e6e6e6"
  })), _path38 || (_path38 = /*#__PURE__*/react.createElement("path", {
    d: "m508.416 330.956 233.052 75.548 18.53-57.159-233.053-75.548z",
    fill: "#fff"
  })), _path39 || (_path39 = /*#__PURE__*/react.createElement("path", {
    d: "M548.11 298.837a3.188 3.188 0 0 0-1.966 6.065l180.05 58.366a3.188 3.188 0 1 0 1.968-6.064h-.003zm-5.898 18.193a3.188 3.188 0 0 0-1.966 6.065l180.05 58.366a3.188 3.188 0 0 0 1.98-6.06l-.014-.004z",
    fill: "#6c63ff"
  })), _path40 || (_path40 = /*#__PURE__*/react.createElement("path", {
    d: "M730.32 365.075a7.536 7.536 0 0 0-.397-11.549l8.648-25.347-13.47 3.5-6.147 23.533a7.577 7.577 0 0 0 11.366 9.863z",
    fill: "#ffb7b7"
  })), _path41 || (_path41 = /*#__PURE__*/react.createElement("path", {
    d: "m734.183 349.694-13.069-5.826 4.391-44.215-4.086-44.586 17.446-9.418 3.698 4.663.004.106 1.96 56.38-.01.042z",
    fill: "#3f3d56"
  })), _path42 || (_path42 = /*#__PURE__*/react.createElement("path", {
    d: "M1004.036 548.695H320.588a1.567 1.567 0 0 1-1.539-1.134 1.53 1.53 0 0 1 1.477-1.919h683.385a1.615 1.615 0 0 1 1.616 1.194 1.528 1.528 0 0 1-1.49 1.859zm-774 0H1.588A1.567 1.567 0 0 1 .05 547.56a1.53 1.53 0 0 1 1.477-1.919h228.385a1.615 1.615 0 0 1 1.616 1.194 1.528 1.528 0 0 1-1.49 1.859z",
    fill: "#ccc"
  })));
};
/* harmony default export */ var icon = (SvgIcon);
// EXTERNAL MODULE: ./src/context/index.js + 3 modules
var context = __webpack_require__(62675);
;// CONCATENATED MODULE: ./src/pages/contact-us/layout/Layout.component.js










var Layout = function(param) {
    var title = param.title, subtitle = param.subtitle, children = param.children;
    var ref = (0,esm/* useTranslation */.$G)("page-contact-us", "common"), t = ref.t, i18n = ref.i18n;
    var ref1 = (0,react.useContext)(context/* AuthContext */.Vo), login = ref1.login, isAnonymous = ref1.isAnonymous;
    var ref2 = (0,dist/* default */.ZP)("contactUs.qualifications"), resp = ref2.data;
    var lang = t("script", {
        returnObjects: true
    });
    if (isAnonymous) {
        login();
        return null;
    }
    var main = /*#__PURE__*/ (0,jsx_runtime.jsxs)(Main, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Header, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        children: title
                    }),
                    subtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: subtitle
                    })
                ]
            }),
            children
        ]
    });
    if (!resp) {
        main = /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorContainer, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton/* default */.Z, {
                active: true
            })
        });
    }
    var data = (resp === null || resp === void 0 ? void 0 : resp.data) || {};
    var isAnyDetectionFalse = es/* any */.YjB(es/* equals */.fS0(es.__, false))(es/* values */.VO0(data));
    var Prerequisite = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: es/* intersperse */.iDB(i18n.language === "zh" ? "\u3001" : ", ", [
                data.company_info_is_completed === false && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "/my/company",
                    children: lang.completeCompanyInfo
                }, "company-info"),
                data.phone_email_is_completed === false && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "/my/settings",
                    children: lang.completeContactInfo
                }, "contact-info"), 
            ].filter(Boolean))
        });
    };
    if (isAnyDetectionFalse) {
        main = /*#__PURE__*/ (0,jsx_runtime.jsxs)(ErrorContainer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(icon, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Trans */.cC, {
                        t: t,
                        i18nKey: "script.noPermission",
                        components: {
                            prerequisite: /*#__PURE__*/ (0,jsx_runtime.jsx)(Prerequisite, {})
                        }
                    })
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
        children: [
            main,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Footer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "\xa9"
                    }),
                    t("common:footer.copyright")
                ]
            })
        ]
    });
};
/* harmony default export */ var Layout_component = (Layout);

;// CONCATENATED MODULE: ./src/pages/contact-us/layout/index.js



/***/ })

}]);